import QQBarAndLabel from './QQBarAndLabel';

export default QQBarAndLabel;
